import {MessageName, Query, QueryHandler} from '../../../../messaging/query';
import {BoxPreviewProjection} from './boxPreview';

const VIEW_BOX_PREVIEW_BY_BOX_NUMBER: MessageName = 'view_box_preview_by_box_number';

interface ViewBoxPreviewByBoxNumberPayload {
  readonly boxNumber: number;
}

interface ViewBoxPreviewByBoxNumber extends Query, ViewBoxPreviewByBoxNumberPayload {
  readonly name: typeof VIEW_BOX_PREVIEW_BY_BOX_NUMBER;
}

interface ViewBoxPreviewByBoxNumberFunction {
  (payload: ViewBoxPreviewByBoxNumberPayload): ViewBoxPreviewByBoxNumber;
}

const viewBoxPreviewByBoxNumber: ViewBoxPreviewByBoxNumberFunction = payload => ({
  name: VIEW_BOX_PREVIEW_BY_BOX_NUMBER,
  ...payload,
});

export type ViewBoxPreviewByBoxNumberResult = BoxPreviewProjection | null;

export interface BoxPreviewByBoxNumberView {
  (payload: ViewBoxPreviewByBoxNumberPayload): Promise<ViewBoxPreviewByBoxNumberResult>;
}

export type ViewBoxPreviewByBoxNumberHandler = QueryHandler<ViewBoxPreviewByBoxNumber, ViewBoxPreviewByBoxNumberResult>;

interface ViewBoxPreviewByBoxNumberHandlerFunction {
  (view: BoxPreviewByBoxNumberView): ViewBoxPreviewByBoxNumberHandler;
}

const viewBoxPreviewByBoxNumberHandlerFunction: ViewBoxPreviewByBoxNumberHandlerFunction =
  view =>
  async ({boxNumber}) =>
    view({boxNumber});

export {viewBoxPreviewByBoxNumber, viewBoxPreviewByBoxNumberHandlerFunction};
